import { CodeAreaKeys } from './store/types';

export const METHOD_SEPARATOR = '//%%%METHOD SEPARATOR%%%';

export const customEventFunctionNames = {
  [CodeAreaKeys.formSubmission]: 'onFormSubmission',
  [CodeAreaKeys.addToCalendar]: 'onSessionAddToCalendar',
  [CodeAreaKeys.registerCtaClick]: 'onRegisterCtaClick',
  [CodeAreaKeys.customCtaClick]: 'onCustomCtaClick'
} as Record<CodeAreaKeys, string>;

export const headStructure = {
  firstLine: '<head>',
  content: `  <!-- Replace this with your Marketing Scripts that belong in the page head -->\n\n\n`,
  lastLine: '</head>'
};

export const bodyStructure = {
  firstLine: '<body>',
  content: `  <!-- Replace this with your Marketing Scripts that belong in the page body -->\n\n\n`,
  lastLine: '</body>'
};

export const formSubmissionStructure = {
  firstLine: `function ${customEventFunctionNames[CodeAreaKeys.formSubmission]}(submissionData, isReRegistration) {`,
  content: ' // Replace this with Javascript you want to fire when a form is submitted\n\n\n',
  lastLine: '}'
};

export const addToCalendarStructure = {
  firstLine: `function ${customEventFunctionNames[CodeAreaKeys.addToCalendar]}(sessionName, sessionId, calendarType) {`,
  content: " // Replace this with javascript you want to fire when a session is added to a user's calendar\n\n\n",
  lastLine: '}'
};

export const registerCtaStructure = {
  firstLine: `function ${
    customEventFunctionNames[CodeAreaKeys.registerCtaClick]
  }(eventId, eventName, blockType, blockId, pageType) {`,
  content: ' // Replace this with javascript you want to fire when register CTAs are clicked\n\n\n',
  lastLine: '}'
};

export const customCtaStructure = {
  firstLine: `function ${
    customEventFunctionNames[CodeAreaKeys.customCtaClick]
  }(ctaText, ctaUrl, blockType, blockId, pageType) {`,
  content: ' // Replace this with javascript you want to fire when Custom CTAs are clicked\n\n\n',
  lastLine: '}'
};

export const allHtmlTags = [
  '!DOCTYPE',
  'a',
  'abbr',
  'address',
  'area',
  'article',
  'aside',
  'audio',
  'b',
  'base',
  'bdi',
  'bdo',
  'blockquote',
  'body',
  'br',
  'button',
  'canvas',
  'caption',
  'cite',
  'code',
  'col',
  'colgroup',
  'data',
  'datalist',
  'dd',
  'del',
  'details',
  'dfn',
  'dialog',
  'div',
  'dl',
  'dt',
  'em',
  'embed',
  'fieldset',
  'figcaption',
  'figure',
  'footer',
  'form',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'head',
  'header',
  'hgroup',
  'hr',
  'html',
  'i',
  'iframe',
  'img',
  'input',
  'ins',
  'kbd',
  'label',
  'legend',
  'li',
  'link',
  'main',
  'map',
  'mark',
  'menu',
  'meta',
  'meter',
  'nav',
  'noscript',
  'object',
  'ol',
  'optgroup',
  'option',
  'output',
  'p',
  'param',
  'picture',
  'pre',
  'progress',
  'q',
  'rp',
  'rt',
  'ruby',
  's',
  'samp',
  'script',
  'search',
  'section',
  'select',
  'small',
  'source',
  'span',
  'strong',
  'style',
  'sub',
  'summary',
  'sup',
  'svg',
  'table',
  'tbody',
  'td',
  'template',
  'textarea',
  'tfoot',
  'th',
  'thead',
  'time',
  'title',
  'tr',
  'track',
  'u',
  'ul',
  'var',
  'video',
  'wbr'
];

/**
 * The guard shown to organizers for raw-JavaScript code areas, which carry no HTML tag to classify.
 *
 * The absent-global check comes first on purpose: no `window.goldcastConsent` means consent is off
 * for the page, so omitting it would silently stop the script for every org without the feature.
 */
export const CONSENT_GUARD_SNIPPET = `if (!window.goldcastConsent || window.goldcastConsent.categories.marketing === 'allowed') {
  // your tracking call
}`;
